// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"02c6e03e","732":"d9a7466d","977":"19708aa3"}[chunkId] + ".chunk.js";
};